import React, { useRef, useState } from 'react'
import { TableSliderFilterProps } from './TableSliderFilter.types'
import styles from './TableSliderFilter.module.scss'
import cl from 'classnames'
import { Input } from '../Input'
import { Slider } from '../Slider'

const TableSliderFilterComponent = (props: TableSliderFilterProps) => {
  const {
    label,
    min,
    max,
    // value,
    onChange,
    className,
    style
  } = props

  const [showSlider, setShowSlider] = useState(false)
  const [stateValue, setStateValue] = useState<number[]>(null)
  const containerRef = useRef(null)

  const onChangeCommitted = (value: number[]) => {
    onChange && onChange(value)
  }

  const handleOutSideClick = (event: MouseEvent) => {
    if (containerRef.current && containerRef.current.contains(event.target)) return

    document.removeEventListener('click', handleOutSideClick, false)
    setShowSlider(false)
  }

  const onInputFocus = () => {
    document.addEventListener('click', handleOutSideClick, false)
    setShowSlider(true)
  }

  const getInputValue = () => {
    if (!stateValue) return ''
    const [minV, maxV] = stateValue
    if (minV === null || maxV === null) return ''
    return `${minV} - ${maxV}`
  }

  return (
    <div
      ref={containerRef}
      className={cl(styles.container, className)}
      style={style}
    >
      <Input
        placeholder='From-To'
        onFocus={onInputFocus}
        autoComplete='none'
        contentEditable={false}
        value={getInputValue()}
        readOnly
      />

      {showSlider && (
        <Slider
          label={label}
          min={min}
          max={max}
          value={stateValue}
          onChange={setStateValue}
          onChangeCommitted={onChangeCommitted}
        />
      )}

    </div>
  )
}

const TableSliderFilter = TableSliderFilterComponent
export { TableSliderFilter }
